import { CustomerService } from "../../services/customerService";
import { Injectable } from "@angular/core";
import { SearchResponse } from "../../objects/responses/searchResponse";
import { OrderService } from "../../services/orderService";
import { CalculatorHelper } from "../../common/helpers/calculatorHelper";
import { OrderSearchRequest } from "../../objects/requests/orderSearchRequest";
import { ActivatedRouteSnapshot } from "@angular/router";
import { UserService } from "../../services/userService";
import { OrderManagementConfig } from "../../objects/users/user";
import { Dictionary } from "lodash";
import { UserViewService } from "../../services/userViewService";
import { BaseResponse } from "../../objects/common/baseResponse";

@Injectable()
export class UserViewResolver {

    constructor(private userViewService: UserViewService) {
    }

    public resolve(route: ActivatedRouteSnapshot): Promise<Dictionary<OrderManagementConfig>> {
        if(this.userViewService.userView)
            return new Promise((resolve, reject) => resolve(this.userViewService.userView));

        return this.userViewService.getUserView().then(x=> {
            return x.Data;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/userView/user-view.resolver.ts